import React from "react";
import HttpServices from "../../../utils/Http.services";
import { conditionalWidth, imageAddress, msToHMS, postWishList } from "../../../utils/useful";

class Video extends React.Component {

  state = {
    data: [],
    info: {},
    like: true,
    videoTime: 0,
    videoPercentage: 0,
    videoIsWatched: '',
    likeComment: {},
    dislikeComment: {},
    comment: [
      { name: 'Sara Joo', date: '2Years ago', src: '/images/video/vid8.jpg', comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
      { name: 'Ali Joojooo', date: '1Years ago', src: '/images/video/vid9.jpg', comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
      { name: 'Morshedi Hosein', date: '2Years ago', src: '/images/video/vid11.jpg', comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
      { name: 'Ali Panahi', date: '4Years ago', src: '/images/video/vid2.jpg', comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
      { name: 'Aqdas', date: '2Years ago', src: '/images/video/vid5.jpg', comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.' },
    ]
  }



  postWishList = (liked) => {


    let info = this.state.info
    info.liked = liked
    this.setState({ info })

    HttpServices.request('postWishList', { course: info._id, status: liked }, (fetchResult, fetchError) => {
      console.log('postWishList', fetchError)


      if (fetchError) {

        info.liked = !liked
        this.setState({ info })
        console.log(fetchError)
        return
      }
      console.log(fetchError)
      console.log('postWishlist', fetchResult)


    })

  }


  sliderChanged = (e, duration) => {
    // console.log(e.target.value)
    let percentage = e.target.value

    let videoPercentage = this.state.videoPercentage
    videoPercentage = percentage

    // this['videoPlayer-'+index].pause()

    this.videoPlayer.currentTime = duration * percentage / 100

    this.videoPlayer.play()

    this.setState({ videoPercentage })

  }

  playVideo = () => {
    this.videoPlayer.play()

    if (this.state.currentVideo != null) {
      this.videoPlayer.pause()

    }

    this.setState({ currentVideo: true })

  }

  // pauseVideo = () => {
  //   this.videoPlayer.pause()

  //   this.setState({ currentVideo: null })
  //   HttpServices.request('videoPaused', { course: data.course, currentLessontime: this.state.videoTime }, (fetchResult, fetchError) => {
  //     console.log('videoPaused', fetchError)


  //     if (fetchError) {

  //       console.log(fetchError)
  //       return
  //     }
  //     console.log(fetchError)
  //     console.log('videoPaused', fetchResult)


  //   })

  // }

  // videoDurationChanged = (e, duration) => {
  //   // console.log(e)
  //   // console.log(e.target.currentTime)

  //   let time = e.target.currentTime
  //   let videoTime = this.state.videoTime
  //   let videoPercentage = this.state.videoPercentage


  //   if (!videoTime) {
  //     videoTime = 0
  //   }

  //   let percentage = time / duration * 100
  //   // console.log(percentage)
  //   videoTime = time
  //   videoPercentage = percentage
  //   this.setState({ videoTime, videoPercentage })
  //   if (this.state.videoPercentage > 95){
  //     if(!this.state.videoIsWatched)
  //     HttpServices.request('videoEnded', { course: data.course }, (fetchResult, fetchError) => {
  //       console.log('videoEnded', fetchError)


  //       if (fetchError) {

  //         console.log(fetchError)
  //         return
  //       }
  //       this.setState({videoIsWatched : true})
  //       console.log(fetchError)
  //       console.log('videoEnded', fetchResult)


  //     })

  //   }

  // }

  noteAction = (item) => {

    this.videoPlayer.pause()
    let time = this.videoPlayer.currentTime ?? 0

    // console.log(item)
    let noteVideo = true
    let currentLesson = item
    this.setState({ noteVideo, currentVideo: null, currentTime: time, currentLesson }, () => {
      this.NoteModal.showModal()

    })


  }

  videoEnded = () => {
    let videoTime = this.state.videoTime
    let videoPercentage = this.state.videoPercentage


    videoTime = null
    videoPercentage = null

    this.setState({ videoTime, videoPercentage, currentVideo: null })

  }

  videoseek = (seekTime, finalTime) => {

    // console.log(index)
    // console.log(this.videoPlayer)
    let time = this.videoPlayer.currentTime
    time = finalTime ?? (time + seekTime)
    this.videoPlayer.currentTime = time
    this.videoPlayer.play()
    this.setState({ currentVideo: true })
  }

  fullScreen = () => {
    let elem = this.videoPlayer

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
      elem.msRequestFullscreen();
    }
    // if (document.exitFullscreen) {
    //   document.exitFullscreen();
    // } else if (document.webkitExitFullscreen) { /* Safari */
    //   document.webkitExitFullscreen();
    // } else if (document.msExitFullscreen) { /* IE11 */
    //   document.msExitFullscreen();
    // }

  }


  //   componentDidMount() {


  //     console.log("Here")
  //     HttpServices.request('getNotes', {}, (fetchResult, fetchError) => {

  //         console.log(fetchError)
  //         console.log(fetchResult)

  //         if (fetchError) {
  //             return
  //         }
  //         console.info(fetchResult)
  //         this.setState({ info: fetchResult.info, data: fetchResult?.notes })
  //     })


  // }
  handleLikeComment = (index) => {
    let likeComment = this.state.likeComment
    let dislikeComment = this.state.dislikeComment


    likeComment[index] = !likeComment[index]

    this.setState({ likeComment })

    // console.log('likeComment', likeComment)
    if (this.state.dislikeComment[index]) {
      dislikeComment[index] = false
      this.setState({ dislikeComment })
    }
  }
  handleDisLikeComment = (index) => {
    let likeComment = this.state.likeComment
    let dislikeComment = this.state.dislikeComment


    dislikeComment[index] = !dislikeComment[index]

    this.setState({ dislikeComment })

    // console.log('likeComment', likeComment)
    if (this.state.likeComment[index]) {
      likeComment[index] = false
      this.setState({ likeComment })
    }
  }


  render() {
    let item = ""
    // this.props.data
    // console.log(item)
    return (

      <div className="box" style={{ backgroundColor: '#1e1e1e' }}>
        <div className="position-relative flexcc video-container">
          <video width="80%" onEnded={() => this.videoEnded()} onTimeUpdate={(e) => this.videoDurationChanged(e, item.video?.duration)} ref={el => this.videoPlayer = el} src='/images/video/videoBcg.mp4' class="adius-1" style={{ margin: "0px auto", maxWidth: 800, objectFit: 'cover' }} />
          {!this.state.currentVideo && (
            <div onClick={() => this.playVideo()} className="position-absolute top-0 left-0 flexcc w-100 h-100 radius-1">
              <img className="play-icon" src="/images/icons/video-circle1.svg" height={90} />
            </div>
          )}
        </div>

        <div className="flexcb mx-auto my-3" style={{ maxWidth: '800px', width: '80%' }}>

          <div>
            <button onClick={() => this.videoseek(+15)}>
              <img className="" src="/images/icons/forward-15-seconds.svg" alt="" />
            </button>
            {!this.state.currentVideo && (
              <button onClick={() => this.playVideo()}>
                <img className="px-2" src="/images/icons/play-circle.svg" alt="" />
              </button>
            )}
            {this.state.currentVideo && (
              <button onClick={() => this.pauseVideo()}>
                <img className="px-2" src="/images/icons/pause-circle.svg" alt="sasa" />
              </button>
            )}
            <button onClick={() => this.videoseek(-15)}>
              <img className=" " src="/images/icons/backward-15-seconds.svg" alt="" />
            </button>
          </div>
          <div className={'' + (conditionalWidth(this.props.width, { xs: 'd-none', md: ' d-flex' }))}>
            <p className="px-2 color-white">
              {msToHMS(item?.video?.duration)}
            </p>
            {/* <Slider className="text-color-1" style={{ maxWidth: "400px" }} aria-label="Volume" max={100} value={this.state.videoPercentage ?? 0} onChange={(e) => this.sliderChanged(e, item?.video?.duration)} /> */}
            <p className="px-2 color-white" style={{ width: 60 }}>
              {this.state.videoTime ? msToHMS(this.state.videoTime) : '00:00'}
            </p>
          </div>

          <button>
            <img className="d-none d-lg-block px-1" src="/images/icons/note-favorite.svg" onClick={() => this.noteAction(item)} />
          </button>

          <button onClick={() => this.fullScreen()} className="">
            <img src="/images/icons/maximize-2.svg" alt="" />
          </button>
          {/* <button>
                <img className="prd-2" src="/images/icons/next.svg" alt="" />
                </button> */}
          {/* <button>
                <img className="" src="/images/icons/previous-2.svg" alt="" />
                </button> */}
        </div>
        {/* comments */}
        <div className="w-100 py-5" style={{ backgroundColor: '#3e3e3e' }}>
          <div className="mx-auto mb-5" style={{ width: '80%' }}>
            <p className="color-white fw-600 mb-2">Description :</p>
            <p className="color-white text-smaller">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam nisi impedit fugit? Voluptate, voluptatem. Atque dicta nesciunt eos reiciendis error quia, modi sed voluptatem quidem saepe vel repellat in, commodi dolorum amet facere possimus odit? Rerum nemo rem necessitatibus labore dignissimos ullam nulla molestiae libero iusto laudantium amet sint natus, eos aliquam? A delectus quod quos sapiente. Doloremque quos quod fugit omnis optio natus ipsum animi sed minima distinctio sunt maiores dolorem vel nihil sequi corporis consequatur eligendi ab, obcaecati ipsam assumenda non debitis cum dolorum! Et voluptatum ipsam placeat impedit sint molestiae nisi quidem animi cupiditate laborum. Inventore eum veritatis ratione? Qui sit velit hic molestiae, aspernatur maxime eum voluptatem iste facere architecto facilis ullam beatae error eligendi ducimus unde aliquid culpa! Quam harum dolorem consequuntur, nulla distinctio facere ullam corrupti modi, excepturi numquam provident expedita molestiae accusamus, dolores commodi fugit amet optio illum eveniet perspiciatis ipsam. Minima quia consequuntur ad, at alias non iusto. Aliquam eum aliquid cum beatae eius, laborum alias nihil eveniet exercitationem sint, doloremque fuga quo repudiandae dignissimos quidem veniam. Aliquam aperiam dignissimos aspernatur rerum eos, praesentium repellendus vel excepturi quibusdam explicabo. Odit, rem reprehenderit debitis, esse id nam deserunt sed, dignissimos eveniet in aliquam quam cumque molestiae temporibus fuga expedita dolor saepe exercitationem mollitia placeat neque aspernatur possimus. Assumenda ex, aliquam illum sint asperiores nisi possimus itaque, ea hic odit fugit earum consequatur molestias fugiat aspernatur quaerat optio accusantium blanditiis illo? Repellat totam iusto aspernatur non, eveniet dolor eum illo nihil asperiores vel ipsa deserunt a optio corrupti necessitatibus, laborum obcaecati. Magnam temporibus earum maxime reiciendis quam officiis sint, atque, voluptatem officia laboriosam, accusantium incidunt porro nesciunt dolore tempore enim sequi! Suscipit quidem, molestias aliquid odit necessitatibus fuga, vitae incidunt, alias et hic autem tempora quis iste? Facilis atque blanditiis illo odit eius officia ex facere qui voluptatem. Itaque quae placeat eius illum quo quidem laborum molestiae ut, est tempore! Sunt consectetur optio fugit et repellendus distinctio quo provident nostrum quam esse, neque ut saepe vel maiores est. Minus alias iusto laudantium iste quisquam praesentium. Voluptas tenetur optio velit accusamus ipsam autem, consequatur quisquam ducimus, esse aspernatur enim minus nulla officiis vitae modi odit laboriosam itaque. Ut, est autem? Dolore culpa officiis asperiores ut maxime at reiciendis a accusamus illum cumque quia, voluptate inventore ipsa et aspernatur quis placeat iure! Eaque accusantium minus exercitationem? Ea dignissimos vitae debitis officia maxime atque temporibus dicta sit.</p>
          </div>
          <div className="mx-auto flexc mb-4" style={{ width: '80%' }}>
            <div className="br-100 mrd-3" style={{ width: '40px', height: '40px' }}>
              <img className="w-100 br-100" src="/images/video/vid5.jpg" alt="" />
            </div>
            <input style={{ borderBottom: '1px solid #eee' }} type="text" className=" py-1 px-3 w-100 transparent-input" placeholder="Add Comment" />
          </div>
          <div className="mx-auto" style={{ width: '80%' }}>
            {this.state.comment.map((prop, index) => {
              return (
                <div className="d-flex mb-4">
                  <div className="br-100 mrd-4" style={{ width: '40px', height: '40px' }}>
                    <img style={{ objectFit: 'cover' }} className="w-100 h-100 br-100" src={prop.src} alt="" />
                  </div>
                  <div className="w-100">
                    <p className="fw-600 text-small color-white">{prop.name}<span className="text-smallest pld-2" style={{ fontWeight: '100' }}>{prop.date}</span></p>
                    <p className="color-white text-smaller">{prop.comments}</p>
                    <div className="flexc my-2">
                      <div className="mrd-4">
                        <img onClick={() => this.handleLikeComment(index)} style={{ display: this.state.likeComment[index] ? "none" : "block" }} height="25px" src="/images/like.png" alt="" />
                        <img onClick={() => this.handleLikeComment(index)} style={{ display: this.state.likeComment[index] ? "block" : "none" }} height="25px" src="/images/solidlike.png" alt="" />
                      </div>
                      <div>
                        <img onClick={() => this.handleDisLikeComment(index)} style={{ display: this.state.dislikeComment[index] ? "none" : "block", transform: 'rotate(180deg)' }} height="25px" src="/images/like.png" alt="" />
                        <img onClick={() => this.handleDisLikeComment(index)} style={{ display: this.state.dislikeComment[index] ? "block" : "none", transform: 'rotate(180deg)' }} height="25px" src="/images/solidlike.png" alt="" />
                      </div>

                    </div>
                    <p className="color-white text-smaller">Reply</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Video;